import { ArtistType } from '@api';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

const formSchema = z.object({
  contractingPartyPersons: z.array(z.string()),
  contractingPartyCompanies: z.array(z.string()),
});

export type ArtistContractingPartyFormSchemaType = z.infer<typeof formSchema>;

type UseArtistContractingPartyFormReturnType =
  UseFormReturn<ArtistContractingPartyFormSchemaType>;

export const useArtistContractingPartyForm = (
  artist: ArtistType
): UseArtistContractingPartyFormReturnType => {
  return useForm({
    defaultValues: {
      contractingPartyPersons: artist.contractingPartyPersons.map(
        (person) => person.id
      ),
      contractingPartyCompanies: artist.contractingPartyCompanies.map(
        (company) => company.id
      ),
    },
    resolver: zodResolver(formSchema),
  });
};
